import './styles.scss';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useEffect } from 'react';

import { AnimatedTransition } from '../../../../../../components/animated-transition';
import { ReportsLoading } from '../../../../../../components/loading/reports-loading';
import { PositionsContext } from '../../../../../../providers/positions/positions-provider';
import Utils from '../../../../../../utils/immersive_utils';
import { getObscuredProps } from '../../../../../../hooks/use-session-tracker';

const { formatNumber } = Utils;
interface IProps {
  data: any[];
  header: any[];
  valuesFormat: any;
  hasAllData: boolean;
  hasOnFilterData: boolean;
}

const OrdersTable = (props: IProps) => {
  const { data, header, valuesFormat, hasAllData, hasOnFilterData } = props;
  const { isLoadingOrders, expandableOrdersRows, setExpandableOrdersRows, isFirstLoadDataOrders } =
    useContext(PositionsContext);

  const handleExpandable = (id: string) => {
    if (!expandableOrdersRows.includes(id)) {
      setExpandableOrdersRows((prev) => [...prev, id]);
    } else {
      setExpandableOrdersRows((prev) => prev.filter((item) => item !== id));
    }
  };

  const renderDataLeft = (block: any[]) => {
    const renderChildrenTableLeft = (arr: any[], level: number) => {
      return arr.map((item, index) => {
        if (!!item.children && item.children.length) {
          return renderNodeItem(item, level, `${item.id}_${index}`);
        } else {
          const hasRpl = !!item['session_rpl']?.length;
          const hasUpl = !!item['session_upl']?.length;

          const classNameSize = hasRpl && hasUpl ? 'size2' : hasRpl || hasUpl ? 'size1' : '';

          return (
            <tr className={`level-${level}`} key={`${item.id}_${index}`}>
              <td style={{ width: '1000px' }} className={item.id === 'spot' ? 'spot' : ''}>
                <div
                  className={`table-item ${classNameSize}`}
                  style={{
                    paddingLeft: `${16 * level}px`,
                    width: '100%',
                  }}
                >
                  <span className="label first-label">{item.label}</span>
                  <span className="label">{/* {item.position} */}</span>
                </div>
              </td>
            </tr>
          );
        }
      });
    };

    const renderNodeItem = (item: any, level: number, key: string) => {
      const childrenLength = item.children ? item.children.length : 0;
      return (
        <tr style={{ width: '100%' }} className={`level-${level}`} key={key}>
          <td style={{ paddingBottom: 0, width: '10000px' }}>
            <div className="cell-node">
              <div
                onClick={() => handleExpandable(item.id)}
                className="node-button"
                style={{
                  paddingLeft: `${16 * level}px`,
                }}
              >
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`icon ${expandableOrdersRows.includes(item.id) && 'rotate'}`}
                />
                <span className="label first-label">
                  {item.label}
                  {childrenLength > 0 && ` (${childrenLength})`}
                </span>
                <span className="label">{item.position}</span>
              </div>
              <div className={`items level-${level}`}>
                {expandableOrdersRows.includes(item.id) &&
                  item.children &&
                  renderChildrenTableLeft(item.children, level + 1)}
              </div>
            </div>
          </td>
        </tr>
      );
    };

    return renderChildrenTableLeft(block, 0);
  };

  const renderDataContent = (block: any[]) => {
    const items: any[] = [];

    const dataLoop = (item: any, parent: string[], level: number) => {
      items.push({
        id: item.id,
        label: item.label,
        parent,
        values: item.values,
        level: level,
        hasChildren: !!item.children && item.children.length,
      });

      if (!!item.children && item.children.length) {
        item.children.forEach((child: any) => {
          dataLoop(child, [...parent, item.id], level + 1);
        });
      }
    };

    block.forEach((item) => {
      dataLoop(item, [], 0);
    });

    return items.map((item, index) => {
      let render = true;

      item.parent.forEach((parent: any) => {
        if (!expandableOrdersRows.includes(parent)) {
          render = false;
        }
      });

      if (!render) return null;

      return (
        <tr className={`level-${item.level}`} key={`${item.id}__${index}`}>
          {item.values.map((val: any, i: number) => {
            let isNegative = false;

            if (valuesFormat[i] && valuesFormat[i]?.type === 'string') {
              return <td key={`${val}_${i}`}>{val}</td>;
            }

            const value = parseFloat(val);

            if (!isNaN(value) && value < 0) {
              isNegative = true;
            }

            if (item.level === 0 || item.level === 1) {
              if (i === 0) {
                return <td key={`${Math.random()}_${i}`}></td>;
              }
            }
            if (item.hasChildren && (i === 7 || i === 6)) {
              return <td key={`${Math.random()}_${i}`}></td>;
            }

            if (isNaN(value)) {
              return (
                <td key={`${val}_${i}`} {...getObscuredProps()}>
                  {val}
                </td>
              );
            }

            if (valuesFormat[i] && valuesFormat[i].sum) {
              return (
                <td key={`${val}_${i}`} {...getObscuredProps()}>
                  {isNegative ? `(${formatNumber(value * -1, 2)})` : formatNumber(value)}
                </td>
              );
            }

            return (
              <td key={`${val}_${i}`} {...getObscuredProps()}>
                {isNegative ? `(${formatNumber(value * -1, 2)})` : value}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  useEffect(() => {
    if (!isFirstLoadDataOrders.current) return;

    if (!hasAllData) return;

    const expandableArr = Utils.expandableArrReportsForLevel(data[0][0]);

    setExpandableOrdersRows(expandableArr);
    isFirstLoadDataOrders.current = false;
  }, [data]);

  const consoleError = console.error;

  console.error = (err: any) => {
    if (err && (typeof err !== 'string' || !err.includes('cannot appear as a child'))) {
      consoleError(err);
    }
  };

  return (
    <div className="orders-table-container" style={{ position: 'relative' }}>
      {!isLoadingOrders && (
        <div className="orders-table">
          <AnimatedTransition className="left-table">
            <table>
              <thead>
                <tr>
                  <th key="instrument">New Orders</th>
                </tr>
              </thead>

              {hasAllData &&
                data?.map((block, index) => {
                  return <tbody key={`left_block_${index}`}>{renderDataLeft(block)}</tbody>;
                })}
            </table>
          </AnimatedTransition>

          <AnimatedTransition className="container-content-table">
            <table className="content-table">
              <thead>
                <tr>
                  {header.map((column) => (
                    <th key={column} style={{ width: '88px' }}>
                      {column}
                    </th>
                  ))}
                </tr>
              </thead>
              {hasAllData &&
                data?.map((block, index) => {
                  return <tbody key={`content_block_${index}`}>{renderDataContent(block)}</tbody>;
                })}
            </table>
          </AnimatedTransition>
        </div>
      )}

      {isLoadingOrders ? (
        <div className="empty-body">
          <ReportsLoading isNoLabel />
        </div>
      ) : !hasAllData ? (
        <div className="empty-body">No positions</div>
      ) : (
        !hasOnFilterData && <div className="empty-body">No results for the selected filters</div>
      )}
    </div>
  );
};

export default OrdersTable;
